var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideList),expression:"!hideList"}]},[_c('v-flex',[_c('v-flex',[_c('policyMedicinesCheckList',{ref:"municipioList",on:{"row-click":_vm.handleMunicipio}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }